import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { StoreProvider } from "./ui/store";
import { App } from "./ui/App";
import { registerServiceWorker } from "./pwa/register";
import { initInstallCapture } from "./pwa/install";
import { initAnalytics } from "./ui/analytics";
import { unlockSoundOnGesture } from "./ui/sound";
import "./ui/styles.css";

registerServiceWorker();
initInstallCapture();
initAnalytics();
unlockSoundOnGesture();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <StoreProvider>
      <App />
    </StoreProvider>
  </StrictMode>,
);
